import {BaseTerms} from "../../../../infrastructure/models/base-terms";

export class LiveStreamingModuleTerms extends BaseTerms {
  WEB_WATCH_LIVE_STREAMING = 'Watch {{Live}} Streaming';
}
